module.exports = __webpack_public_path__ + "img/1524337026.7e1cc3fa.jpg";